import React from 'react';
import styled from 'styled-components';

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  border-radius: 1.25rem;
`;

const StyledHeader = styled.header`
  flex-shrink: 0;
`;

const StyledContent = styled.section`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: auto;
  min-height: 0;
  max-width: 100vw;
`;

const StyledFooter = styled.footer`
  flex-shrink: 0;
`;

type Props = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
};

export function ScreenLayout({ header, footer, children }: Readonly<Props>) {
  return (
    <StyledLayout>
      {header && <StyledHeader>{header}</StyledHeader>}
      <StyledContent>{children}</StyledContent>
      {footer && <StyledFooter>{footer}</StyledFooter>}
    </StyledLayout>
  );
}
